import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/joy';
import SendIcon from '@mui/icons-material/Send';

function StickyMobileCTA({ setOpen }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const showThreshold = 400;

      setIsVisible(scrollPosition > showThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        display: { xs: 'block', md: 'none', lg: 'none' },
        zIndex: 1000,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(100px)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        pointerEvents: isVisible ? 'auto' : 'none',
        '@media (prefers-reduced-motion: reduce)': {
          transition: 'opacity 0.1s'
        }
      }}
    >
      <Button
        fullWidth
        size="lg"
        variant="solid"
        color="primary"
        onClick={() => setOpen(true)}
        sx={{
          borderRadius: '8px',
          boxShadow: '0 10px 40px rgba(0,102,204,0.4)',
          backdropFilter: 'blur(10px)',
          fontWeight: 700,
          fontSize: '16px',
          padding: '16px',
          background: '#0052A3',
          transition: 'all 0.2s ease',
          '&:hover': {
            background: '#003d7a',
            boxShadow: '0 12px 50px rgba(0,102,204,0.5)',
            transform: 'translateY(-2px)'
          },
          '&:active': {
            transform: 'translateY(0)'
          },
          '@media (prefers-reduced-motion: reduce)': {
            '&:hover': {
              transform: 'none'
            }
          }
        }}
        startDecorator={<SendIcon />}
      >
        Contact Representative
      </Button>
    </Box>
  );
}

StickyMobileCTA.propTypes = {
  setOpen: PropTypes.func.isRequired
};

export default StickyMobileCTA;
